import http from '../utils/http'
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

// get请求
/* 首页地图信息 */
export function getHomeLayout (params) {
    return http.get(`/dashboard/dashboard/distribution`, params)
}
/* 分类信息 */
export function getCategoryList (params) {
    return http.get(`/dashboard/dashboard/newsInformation`, params)
}
/* 新闻信息 */
export function getNewsList (params) {
    return http.get(`/dashboard/dashboard/getTitle`, params)
}
/* 首页数据分析 */
export function getHomeCarrier (params) {
    return http.get(`/dashboard/dashboard/carrierData`, params)
}
/* 承运人公示 */
export function getCarrierList (params) {
    return http.get(`/carrierevaluate/carrierEvaluate/list`, params)
}
/* 托运人公示 */
export function getShipperList (params) {
    return http.get(`/shipperevaluate/shipperEvaluate/list`, params)
}
/* 咨询投诉公示 */
export function getFeedbackList (params) {
    return http.get(`feedback/feedback/page/list`, params)
}
/* 文章信息 */
export function getArticle (params) {
    return http.get(`/dashboard/dashboard/getArticles`, params)
}
/* 任务计划 */
export function getProjectList (params) {
    return http.get(`/driverapp/driverapp/getQdGatherPlanList`, params)
}
/* 提交反馈 */
export function postAddFeedback (params) {
    return http.post(`/feedback/feedback/add`, params)
}



// WEBPACK FOOTER //
// ./src/api/api.js